import i18n from 'i18next';
import { Trans } from 'react-i18next';
import { IField, IOption } from 'modules/core/types';
import { ColumnWidth } from 'modules/core/enums';
import { Input } from 'modules/core/components';
import { PATTERNS, UNDERBAR } from 'modules/core/constants';
import {
  requiredValidator,
  validateMinRequiredValueForDropdown,
  validateRequiredMinimumValue,
} from 'modules/core/validators';
import { TelephoneInput } from 'modules/core/components/TelephoneInput';
import { CheckboxGroup } from 'modules/core/components/CheckboxGroup/CheckboxGroup';
import { ConfirmCheckBox } from 'components/Modals/LoanVariablesDialog/components/common/ConfirmCheckBox/ConfirmCheckBox';
import { Select } from 'modules/core/components/Select/Select';

import { UNLOCK_INVENTORY_FIELDS_NAMES } from './fieldNames.const';
import { PHONE_FORMAT } from './consts';

const CREDIR_APPLICATION_SYSTEM_CHECKBOXES: IOption[] = [
  {
    title: i18n.t('components.unlockInventoryDialog.form.routeOneCheckBox'),
    value: i18n.t('components.unlockInventoryDialog.form.routeOneCheckBox') as string,
  },
  {
    title: i18n.t('components.unlockInventoryDialog.form.dealertrackCheckBox'),
    value: i18n.t('components.unlockInventoryDialog.form.dealertrackCheckBox') as string,
  },
];

export const UNLOCK_INVENTORY_FIELDS: IField[] = [
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.FULL_NAME,
    label: i18n.t('components.unlockInventoryDialog.form.fullNameLabel'),
    component: Input,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      maxLength: 300,
      required: true,
      valueAsNumber: false,
      rules: requiredValidator,
      placeholderWithoutAsterisk: true,
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.EMAIL,
    label: i18n.t('components.unlockInventoryDialog.form.emailLabel'),
    component: Input,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      required: true,
      valueAsNumber: false,
      rules: {
        required: true,
        pattern: {
          value: PATTERNS.EMAIL_PATTERN,
          message: i18n.t('common.errorMessages.emailMessage'),
        },
      },
      placeholderWithoutAsterisk: true,
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.PHONE_NUMBER,
    label: i18n.t('components.unlockInventoryDialog.form.phoneNumberLabel'),
    component: TelephoneInput,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      required: true,
      rules: {
        required: true,
        pattern: {
          value: PATTERNS.PHONE_PATTERN_10_NUMBERS,
        },
      },
      validate: validateRequiredMinimumValue,
      format: PHONE_FORMAT,
      mask: UNDERBAR,
      hideInitZeroValue: true,
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.DEALERSHIP_NAME,
    label: i18n.t('components.unlockInventoryDialog.form.dealershipNameLabel'),
    component: Input,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      required: true,
      valueAsNumber: false,
      rules: requiredValidator,
      placeholderWithoutAsterisk: true,
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.DEALERSHIP_STATE,
    label: i18n.t('components.unlockInventoryDialog.form.dealershipStateLabel'),
    component: Select,
    controlProps: {
      options: [],
      fieldWidth: ColumnWidth.FULL,
      required: true,
      rules: requiredValidator,
      validate: validateMinRequiredValueForDropdown,
      placeholder: i18n.t('components.unlockInventoryDialog.form.dropdownPlaceholder'),
      selectProps: { isClearable: true },
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.INVENTORY_SYNDICATION_PROVIDER,
    label: i18n.t('components.unlockInventoryDialog.form.inventorySyndicationProviderLabel'),
    component: Select,
    controlProps: {
      options: [],
      fieldWidth: ColumnWidth.FULL,
      required: false,
      placeholder: i18n.t('components.unlockInventoryDialog.form.dropdownPlaceholder'),
      selectProps: { isClearable: true },
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.CREDIR_APPLICATION_SYSTEM,
    label: i18n.t('components.unlockInventoryDialog.form.creditApplicationSystemLabel'),
    component: CheckboxGroup,
    controlProps: {
      options: CREDIR_APPLICATION_SYSTEM_CHECKBOXES,
      fieldWidth: ColumnWidth.FULL,
    },
  },
];

export const UNLOCK_INVENTORY_CONFIRM_CHECKBOXES: IField[] = [
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.CONFIRM_PRICE,
    component: ConfirmCheckBox,
    textLabel: i18n.t('components.unlockInventoryDialog.form.priceCheckBox'),
    controlProps: {
      rules: requiredValidator,
      isSetErrorOnUncheck: true,
    },
  },
  {
    name: UNLOCK_INVENTORY_FIELDS_NAMES.CONFIRM_TERMS,
    component: ConfirmCheckBox,
    textLabel: (
      <Trans
        defaults={i18n.t('components.unlockInventoryDialog.form.termsAndConditionsCheckBox')}
        components={[
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a href={process.env.REACT_APP_STREAMLINE_TERMS_SITE} target="_blank" rel="noreferrer" />,
        ]}
        style={{ display: 'inline' }}
      />
    ),
    controlProps: {
      rules: requiredValidator,
      isSetErrorOnUncheck: true,
    },
  },
];
